import { render, staticRenderFns } from "./courseSearch.vue?vue&type=template&id=7bca3a35&"
import script from "./courseSearch.vue?vue&type=script&lang=js&"
export * from "./courseSearch.vue?vue&type=script&lang=js&"
import style0 from "./courseSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports